import { Pagination } from 'lib/types/shared';
import { Dispatch } from 'redux';

export interface BaseOperation {
  id: number;
  folioId?: number;
  businessIdentifier: string;
  createdAt: string;
  updatedAt: string;
}

export interface OperationTypeConfig {
  key: string;
  label: string;
  apiEndpoint: string;
  tableHeaders: Array<{
    label: string;
    key: string;
    type?: string;
  }>;
  getLabel: (operation: BaseOperation | null) => string;
  fetchData: (
    dispatch: Dispatch,
    page: number,
    pageSize: number,
    businessIdentifier: string | undefined,
  ) => Promise<{ data: BaseOperation[]; pagination: Pagination }>;
}

export interface OperationValue {
  enabled: boolean;
  operationType?: string;
  operation?: BaseOperation;
}

// Operation type registry
export const OPERATION_TYPES: Record<string, OperationTypeConfig> = {
  'warranty-request': {
    key: 'warranty-request',
    label: 'Garantías',
    apiEndpoint: 'internal/sgrWarrantyRequest',
    tableHeaders: [
      {
        label: 'ID',
        key: 'folioId',
        type: 'numeric-id',
      },
      {
        label: 'Tipo',
        key: 'translatedType',
      },
      {
        label: 'Cliente',
        key: 'businessName',
      },
      {
        label: 'Estado',
        key: 'translatedStatus',
        type: 'status',
      },
      {
        label: 'Monto Cotizado',
        key: 'quotedAmount',
        type: 'money',
      },
      {
        label: 'Moneda',
        key: 'quotedCurrency',
      },
      {
        label: 'Costo de emisión',
        key: 'premium',
        type: 'money',
      },
    ],
    getLabel: (operation: BaseOperation | null) =>
      `Garantía ${operation?.folioId}`,
    fetchData: async (dispatch, page, pageSize, businessIdentifier) => {
      const { getSGRWarrantyRequests } = await import('lib/api/sgr');
      const query = `page=${page}&pageSize=${pageSize}&businessIdentifier=${businessIdentifier}&status=ACTIVE,CLAIMED,CANCELLED`;
      return await getSGRWarrantyRequests(dispatch, query);
    },
  },
};
